import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import {
  AutomatedNotificationType,
  IMarketingCampaignStep,
  InteractionType,
  interactionTypeDisplayMap,
  isGeneratedTask,
} from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';

@Component({
  selector: 'pr-campaign-step-icon',
  templateUrl: './campaign-step-icon.component.html',
  styleUrl: './campaign-step-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex',
  },
  imports: [MatIcon, MatTooltip, NgCommonModule],
})
export class CampaignStepIconComponent {
  campaignStep = input.required<WithRef<IMarketingCampaignStep>>();
  tooltip = computed(() => this._getStepTooltip(this.campaignStep()));
  icon = computed(() => this._getStepIcon(this.campaignStep()));
  interactionType = computed(() =>
    this._getStepInteractionType(this.campaignStep())
  );

  private _getStepTooltip(step: IMarketingCampaignStep): string {
    if (isGeneratedTask(step.config)) {
      return 'Create a Task';
    }

    if (step.config.type === AutomatedNotificationType.EMAIL) {
      return 'Send an Email';
    }

    return 'Send an SMS';
  }

  private _getStepInteractionType(
    step: IMarketingCampaignStep
  ): InteractionType {
    if (isGeneratedTask(step.config)) {
      return InteractionType.Task;
    }

    if (step.config.type === AutomatedNotificationType.EMAIL) {
      return InteractionType.Email;
    }

    if (step.config.type === 'webhook') {
      return InteractionType.Webhook;
    }

    if (step.config.type === 'partner') {
      return InteractionType.PartnerIntegration;
    }

    return InteractionType.Sms;
  }

  private _getStepIcon(step: IMarketingCampaignStep): string {
    const interactionType = this._getStepInteractionType(step);
    return interactionTypeDisplayMap[interactionType];
  }
}
